import { Box } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { AuthStore, RoutingStore } from 'stores';
import { Tree } from 'stores/tree';
import { UserType } from 'types';
import { ContentTreeView, DataHierarchy, Loading } from 'views';


export interface IStatisticsTreeViewProps {
  routingStore?: RoutingStore,
  authStore?: AuthStore,
}

export const TreeContext = React.createContext<Tree>(new Tree({}));
export const StatisticsTreeView = inject("routingStore", "authStore")(observer((props: IStatisticsTreeViewProps): JSX.Element => {
  const { routingStore } = props;
  const tree = React.useContext(TreeContext);

  React.useEffect(() => {
    if([UserType.Analyst, UserType.Manager].includes(props.authStore.getCurUser.user_type)) {
      tree.toggleShowFakeData(true);
    }
    tree.load();
    return tree.destroy;
  }, []);
  
  return (
    <TreeContext.Provider value={tree}>
      <Box width="100%" height="fit-content" mt="2rem" display="flex" flexDirection="row">
        <DataHierarchy /> 
        {routingStore.isLoading ? <Loading sx={{width: "100%", alignItems: "start"}}/> : <ContentTreeView />}
      </Box>
    </TreeContext.Provider>
  );
}));